import React, { useState } from "react";
import axios from "axios";
import {
  FormControl,
  TextField,
  Select,
  MenuItem,
  Button,
  CircularProgress,
  Alert,
  FormHelperText,
} from "@mui/material";

import { VAVE, ADMINUPDATEIL2 } from "../../AppConstant";
import { sourcingEmpIds } from "../switch_on_userlist";

import { toWords } from "number-to-words";

function AlertDialogForm({ request, setRefreshApi }) {
  const pdReassignUsers = [
    { id: 1, empName: "Prabhu Shanmugam(Electrical)", empId: "300420" },
    { id: 2, empName: "Nandkumar Patil(Bus Body)", empId: "300669" },
    { id: 3, empName: "Govindaraj D(Battery)", empId: "300182" },
    // { id: 4, empName: "Karthik Babu Javvaji(Chassis)", empId: "300282" },
    { id: 4, empName: "Karthik VS(Chassis)", empId: "300321" },
    // { id: 5, empName: "Javid", empId: "EL_0003" },
    { id: 5, empName: "Prabhakaran K(Electrical)", empId: "300106" },
    // { id: 6, empName: "Sivakumar Muthandi(Electrical)", empId: "300454" },
  ];

  const sourcingReassignUsers = [
    { id: 1, empName: "Kuppu raj Rajagopal(Electrical)", empId: "300740" },
    { id: 2, empName: "Selva Sundaram(Battery)", empId: "300197" },
    // { id: 3, empName: "Vishal Maggon(Bus Body)", empId: "300680" },
    { id: 3, empName: "RAJARAM KULANTHAIVEL(Bus Body)", empId: "300639" },
    { id: 4, empName: "Prathivraj C(Chassis)", empId: "300088" },
    // { id: 5, empName: "Vignesh", empId: "300381" },
  ];

  const [pdSelectedUser, setPdSelectedUser] = useState(null);
  const [sourcingselectedUser, setSourcingSelectedUser] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [inputValue, setInputValue] = useState(request.benefit);
  const numberToWords = (num) => {
    if (!num) return "";
    return toWords(Number(num)) + " rupees";
  };
  const handleSubmit = async () => {
    setLoading(true);
    setError(null);
    setSuccess(null);

    const formData = new FormData();
    if (sourcingselectedUser !== null) {
      formData.append("il1_sourcing_assigned_id", sourcingselectedUser.empId);
      formData.append("il1_sourcing_assigned", sourcingselectedUser.empName);
    }

    if (pdSelectedUser !== null) {
      formData.append("il1_pd_assigned_id", pdSelectedUser.empId);
      formData.append("il1_pd_assigned", pdSelectedUser.empName);
    }

    if (inputValue !== "") {
      formData.append("benefit", inputValue);
    }
    formData.append("ideaids", request?.id_x ?? "");
    try {
      await axios.post(VAVE + ADMINUPDATEIL2, formData, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      setSuccess("Submitted successfully!");
      setRefreshApi(true);
      setPdSelectedUser(null);
      setSourcingSelectedUser(null);
      setInputValue("");
    } catch (error) {
      console.error("Upload failed:", error);
      setError("Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}
      {success && (
        <Alert severity="success" sx={{ mb: 2 }}>
          {success}
        </Alert>
      )}
      <FormControl fullWidth sx={{ mb: 2 }}>
        <FormHelperText id="user-select-label">Sourcing</FormHelperText>
        <Select
          labelId="user-select-label"
          value={sourcingselectedUser?.id || ""}
          onChange={(e) => {
            const user = sourcingReassignUsers.find(
              (u) => u.id === e.target.value,
            );
            setSourcingSelectedUser(user);
          }}
          disabled={loading}
        >
          {sourcingReassignUsers.map((user) => (
            <MenuItem key={user.id} value={user.id}>
              {user.empName} ({user.empId})
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl fullWidth sx={{ mb: 2 }}>
        <FormHelperText id="user-select-label">Pd</FormHelperText>
        <Select
          labelId="user-select-label"
          value={pdSelectedUser?.id || ""}
          onChange={(e) => {
            const user = pdReassignUsers.find((u) => u.id === e.target.value);
            setPdSelectedUser(user);
          }}
          disabled={loading}
        >
          {pdReassignUsers.map((user) => (
            <MenuItem key={user.id} value={user.id}>
              {user.empName} ({user.empId})
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <label htmlFor="savings">Benefits / Tentative Savings*</label>
      <input
        type="text"
        id="savings"
        className="form-control"
        placeholder="Enter Savings"
        value={inputValue}
        style={{ marginBottom: "10px" }}
        onChange={(e) => {
          const value = e.target.value;
          if (/^\d*$/.test(value)) {
            setInputValue(value);
          }
        }}
        inputMode="numeric"
        required
      />
      {inputValue && (
        <small
          style={{
            color: "gray",
            marginTop: "5px",
            marginBottom: "5px",
            display: "block",
          }}
        >
          {numberToWords(inputValue)}
        </small>
      )}

      <Button
        variant="contained"
        color="primary"
        onClick={handleSubmit}
        disabled={loading}
        startIcon={loading ? <CircularProgress size={20} /> : null}
      >
        {loading ? "Reassigning..." : "Reassign"}
      </Button>
    </div>
  );
}

export default AlertDialogForm;
